import { Injectable } from '@angular/core';
import { DocumentModel } from './document.model';
import { FileUrl } from './models/file-url.model';
import { DemandeType } from '@lib/models/non-conformite/demande-type.model';

@Injectable({ providedIn: 'root' })
export abstract class GedService {
  public abstract getDemandeAffiliationFileUrl(gedId: string): Promise<string>;
  public abstract getDemandeValidationPjFileUrl(gedId: string): Promise<string>;
  public abstract getDemandeHabilitationFileUrl(
    gedId: string,
    isRetourNc?: boolean,
    demandeHabilitationPublicId?: string
  ): Promise<string>;
  public abstract uploadFile(file: File, uri: string): Promise<void>;
  public abstract getDocumentFileUrls(
    document: DocumentModel,
    type?: DemandeType,
    demandeHabilitationPublicId?: string
  ): Promise<FileUrl[]>;
}
